import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import AdminLogin from './AdminLogin';

// Auth gate scoped to a single game's own Firebase Auth instance. Each game
// has its own Firebase project, so signing into one game has no effect on
// the others — this component only ever watches the `auth` instance it is
// given, which is what makes per-game login work correctly when switching
// between /zip, /neon, /jelly.
const RequireGameAuth = ({ auth, title, footnote, errorMessage, busyLabel, children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return unsubscribe;
  }, [auth]);

  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }

  if (!user) {
    return (
      <AdminLogin
        auth={auth}
        title={title}
        footnote={footnote}
        errorMessage={errorMessage}
        busyLabel={busyLabel}
      />
    );
  }

  return typeof children === 'function' ? children(user) : children;
};

export default RequireGameAuth;
